<template>
  <div class="findpaypasswordTypePage">   
    <XR-head titleText="选择找回方式" :rightShow="false" ref="head"></XR-head>
      
    <mu-list class="checkType" v-if="!loaded">
      <mu-list-item  title="手机" @click="goPhone">
        <mu-icon slot="left" value=":fa fa-phone"/>
        <mu-icon value=":fa fa-angle-right" slot="right"></mu-icon>
      </mu-list-item>
      <mu-divider shallowInset/>
      <mu-list-item  title="邮箱" @click="goEmail">
        <mu-icon slot="left" value=":fa fa-envelope-o"/>
        <mu-icon value=":fa fa-angle-right" slot="right"></mu-icon>
      </mu-list-item>
      <mu-divider shallowInset/>
    </mu-list>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>
<script>
export default {
  data () {
    return {
      loaded:true,
      isTestPhone:false,
      isTestEmail:false
    }
  },
  mounted(){
    this.getMemberInfo()
  },
  methods:{    
    getMemberInfo(){
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetUserInfo"
      ).then(function(res) {
        ths.loaded =false          
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.$refs.XRtoast.hide()
          ths.isTestPhone = res.Data.IsTestPhone
          ths.isTestEmail = res.Data.IsTestEmail
        }
      });      
    },
    goPhone(){
      if(!this.isTestPhone){
          this.$refs.XRtoast.failed('您未绑定手机', true)
          return
      }
      this.$router.push("/usercenter/paypasswordReset")
    },
    goEmail(){
      if(!this.isTestEmail){
          this.$refs.XRtoast.failed('您未绑定邮箱', true)
          return
      }
      this.$router.push("/usercenter/paypasswordResetByEmail")
    }
  }
}
</script>
<style>
    body .findpaypasswordTypePage{
      
      background: #fff;
    }
    .findpaypasswordTypePage .checkType{
      padding: 0;
    }
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/FindPayPasswordType.vue